import { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { CAJACHICA_REGISTRAR_TRABAJADORES_LISTA, CAJACHICA_REGISTRAR_TRABAJADORES_NUEVO } from 'constants/codigosTransacciones'

import ListaTrabajadoresPage from './lista'
import NuevoTrabajadoresPage from './nuevo'

export default function RegistrarTrabajadoresPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${CAJACHICA_REGISTRAR_TRABAJADORES_NUEVO}/:id`} component={NuevoTrabajadoresPage} />
        <Route path={`/${CAJACHICA_REGISTRAR_TRABAJADORES_NUEVO}`} component={NuevoTrabajadoresPage} />
        <Route path={`/${CAJACHICA_REGISTRAR_TRABAJADORES_LISTA}`} component={ListaTrabajadoresPage} />
      </Switch>
    </Suspense>
  )
}
